
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/course/[...id]",
      function () {
        return require("private-next-pages/course/[...id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/course/[...id]"])
      });
    }
  